module.exports = __webpack_public_path__ + "static/media/mixdish.e804f7a2.png";